import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const overrides: NonNullable<
  Components<CssVarsTheme>['MuiBreadcrumbs']
>['styleOverrides'] = {
  root: () => ({
    '.MuiBreadcrumbs-li a': {
      color: 'inherit',
      fontWeight: 500,
      textDecoration: 'none',
    },
  }),
};

const styleOverrides: Pick<Components<CssVarsTheme>['MuiBreadcrumbs'], never> =
  {
    styleOverrides: overrides,
  };

export default styleOverrides;
